import fuzzysort from 'fuzzysort';

import { isListOfObjects, isListOfStrings } from '../../types/utils';
import { normalizeText } from './helpers';

export interface Options {
  fieldNames: string[];
}

export function searchFuzzy(searchTerm: string, items: string[]): string[];

export function searchFuzzy<Item = unknown>(searchTerm: string, items: Item[], options: Options): Item[];

export function searchFuzzy<Item = unknown>(searchTerm: string, items: Item[], options?: Options) {
  const threshold = -100000; // 0 returns perfect match
  const normalizedSearchTerm = normalizeText(searchTerm)
    .replace(/[^\w\s]/gi, '')
    .toLowerCase();

  if (isListOfStrings(items)) {
    return fuzzysort.go(normalizedSearchTerm, items, { all: true, threshold }).map((r) => r.target);
  }

  if (isListOfObjects<Item>(items) && options?.fieldNames?.length) {
    return fuzzysort
      .go(normalizedSearchTerm, items, { all: true, threshold, keys: options?.fieldNames })
      .map((r) => r.obj);
  }

  return items;
}

export default searchFuzzy;
